<template>
    <el-dialog title="签署详情" :visible.sync="visible" width="900px" :before-close="handleClose">
        <el-table v-loading="listLoading" border :data="tableData" style="width: 100%">
            <el-table-column label="序号" width="80">
                <template slot-scope="scope">{{ scope.$index + 1 }}</template>
            </el-table-column>
            <el-table-column prop="contractNo" label="合同编号" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="signNumber" label="签署批次号" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="signFileNo" label="签署文件编号" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="signFileName" label="签署文件名" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="type" label="签署类型" width="120" show-overflow-tooltip>
                <template slot-scope="{ row }">{{ dictData['SRM_SUPPLIER_DIRVER_SIGN_TYPE'][row.type] }}</template>
            </el-table-column>
            <el-table-column prop="contractUser" label="签署人" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="contractUserMobile" label="签署手机号" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="contractStatus" label="签署状态" width="100" show-overflow-tooltip>
                <template slot-scope="{ row }">
                    {{ dictData['SRM_SUPPLIER_DELEGATE_STATUS'][row.contractStatus] }}
                </template>
            </el-table-column>
            <el-table-column prop="signTime" label="签署时间" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="remark" label="签署失败原因" width="180" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="80" fixed="right">
                <template slot-scope="{ row }">
                    <!-- 签署状态=签署失败 && 签署类型=直通宝签署  则显示按钮 -->
                    <el-button :loading="row.loading" v-if="row.contractStatus === '-1' && row.type === '2'" type="text" @click="rePush(row)">
                        重推
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>
<script>
import {
    supplierDelegateManageRecordDetail,
    supplierDelegateManageRecordRePush,
} from '../../../../../api/driverDelegateLetter.js'
import { dictWithUrl } from '@/components/lots/api'

export default {
    name: 'detail',
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            listLoading: false,
            tableData: [],
            dictData: {},
        }
    },
    watch: {
        visible(v) {
            if (v) {
            }
        },
    },
    methods: {
        handleClose() {
            this.$emit('update:visible', false)
        },
        rePush(row) {
            this.$set(row, 'loading', true)
            supplierDelegateManageRecordRePush({ contractNo: row.contractNo })
                .then(res => {
                    this.$message.success('已重推!');
                    this.getList(row.contractNo)
                })
                .finally(() => {
                    this.$set(row, 'loading', false)
                })
        },
        getList(contractNo) {
            this.listLoading = true
            supplierDelegateManageRecordDetail({ contractNo })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.tableData = res.data || []
                    }
                })
                .finally(() => {
                    this.listLoading = false
                })
        },
    },
    mounted() {
        dictWithUrl('SRM_SUPPLIER_DIRVER_SIGN_TYPE,SRM_SUPPLIER_DELEGATE_STATUS').then(res => {
            if (res && +res.code === 0) {
                this.dictData = res.data
            }
        })
    },
}
</script>
<style lang="less" scoped>
</style>
